import { combineReducers } from 'redux';
import { takeEvery, put, select } from 'redux-saga/effects';
import { LOCATION_CHANGE } from 'react-router-redux';
import sEmitter from '@gorangajic/storage-emitter';
import PromiseCreator from 'promise-creator';
import queryString from 'query-string';
import actionKey from '../utils/action-key';
import takeOnlyFirst from '../utils/take-only-first';
import { FETCH_ME } from './me';
import {
    LOGOUT,
    AUTHENTICATION_ERROR,
    AUTH_LEVEL_CHECK,
    SET_LEVEL,
    LOGIN,
    SIGNUP,
    updateTokenAction,
    authLevelCheckAction,
} from './auth';

export const RESET_STATE = 'RESET_STATE';
export const APP_INITIALIZED = 'app/APP_INITIALIZED';
export const CHANGE_VIEW = 'app/CHANGE_VIEW';
export const INITIALIZE_CHANGE_VIEW = 'app/CHANGE_VIEW';
export const SYNC_LOGGED_IN_USER = 'app/SYNC_LOGGED_IN_USER';

export const COUNSELOR_VIEW = 'COUNSELOR_VIEW';
export const STUDENT_VIEW = 'STUDENT_VIEW';

export const appInitializedAction = () => ({
    type: APP_INITIALIZED,
});

export const viewReducer = (state = null, action) => {
    switch (action.type) {
        case CHANGE_VIEW:
            return action.view;
        case SET_LEVEL:
        case actionKey.success(AUTH_LEVEL_CHECK): {
            const accessLevel = parseInt(action.payload, 10);
            return accessLevel < 5 ? COUNSELOR_VIEW : STUDENT_VIEW;
        }
        case actionKey.success(SIGNUP):
        case actionKey.success(LOGIN): {
            const accessLevel = parseInt(action.payload.level, 10);
            return accessLevel < 5 ? COUNSELOR_VIEW : STUDENT_VIEW;
        }
        default:
            return state;
    }
};

export const loading = (state = true, action) => {
    if (action.type === APP_INITIALIZED) {
        return false;
    }
    return state;
};

export default combineReducers({
    view: viewReducer,
    loading,
});

export const changeViewAction = view => ({
    type: CHANGE_VIEW,
    view,
});


export function* rootSaga() {
    yield [
        takeOnlyFirst(LOCATION_CHANGE, initializeApp),
        takeEvery([LOGOUT, AUTHENTICATION_ERROR], resetState),
        takeEvery([
            actionKey.success(FETCH_ME),
            actionKey.success(LOGIN),
            actionKey.success(SIGNUP),
        ], syncUserData),
    ];
}

export function* resetState() {
    const { theme, router, app, auth } = yield select();
    yield put({
        type: RESET_STATE,
        state: { theme, router, app, auth: { resetPassword: auth.resetPassword } },
    });
}

export const syncLoggedInUserAction = ({ user, scores = {}, level, token }) => ({
    type: SYNC_LOGGED_IN_USER,
    payload: {
        user,
        scores,
        level,
        token,
    },
});

/**
 * sync user login data, with other tabs
 * payload: { user, scores, level }
 */
export function* syncUserData({ payload }) {
    const { auth: { token } } = yield select();
    // check because signup
    // does not log in user
    // if he is not verified(admin)
    if (payload.level) {
        yield sEmitter.emit('user-sync', {
            token,
            ...payload,
        });
    }
}

export function* initializeApp({ payload }) {
    const search = payload.search;
    const { temptag, token } = search ? queryString.parse(search) : {};
    if (temptag || token) {
        const { theme, router } = yield select();
        yield put({
            type: RESET_STATE,
            state: { theme, router },
        });
        const { promise, resolve } = PromiseCreator();
        if (token) {
            yield put(updateTokenAction(token));
        }
        yield put(authLevelCheckAction({ tag: temptag, resolve }));
        yield promise;
    }

    yield put(appInitializedAction());
}



// WEBPACK FOOTER //
// ./src/client/redux/app.js